import { ISearchParams } from "../types/global/SearchParams.interface";

export const formatQuery = (params: ISearchParams) => {
  const { filters, ...paramsWithoutFilters } = params;

  let query = Object.keys(paramsWithoutFilters)
    .filter(key => paramsWithoutFilters[key])
    .map(key => `${key}=${paramsWithoutFilters[key]}`)
    .join("&");

  if (filters && Object.keys(filters).length > 0) {
    Object.keys(filters).forEach(filterKey => {
      const filterValues = filters[filterKey];

      filterValues?.forEach(valueConfig => {
        const previousQuery = query ? `${query}&` : "";
        const filterValue = valueConfig.value || valueConfig.name;
        const filterValueQuery =
          filterValue && `${valueConfig.filterKey || filterKey}=${filterValue}`;
        const filterQueryValue = valueConfig.customValue || filterValueQuery;

        if (filterQueryValue) {
          query = `${previousQuery}${filterQueryValue}`;
        }
      });
    });
  }

  return query;
};
